import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import {
  GERAR_CONTA_AGORA_CONCILIACAO,
  GERAR_CONTA_AGORA_CONCILIACAO_PENDING,
  GERAR_CONTA_AGORA_CONCILIACAO_SUCCESS,
  GERAR_CONTA_AGORA_CONCILIACAO_FAILURE,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError, AlertSuccess } from '@components/common/AlertToast';

function* sagaGerarContaAgoraConciliacao(action) {
  yield put({ type: GERAR_CONTA_AGORA_CONCILIACAO_PENDING, id: action.id })

  try {
    yield call(conciliacaoBancariaService.gerarContaAgoraConciliacao, action.id);

    yield put({ type: GERAR_CONTA_AGORA_CONCILIACAO_SUCCESS })

    AlertSuccess('Próximo vencimento da conta gerado com sucesso!');

    // Recarrega os dados da aba de contas recorrentes
    if (action.filters) {
      yield put({
        type: NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO,
        args: action.filters
      });
    }

  } catch (error) {
    yield put({ type: GERAR_CONTA_AGORA_CONCILIACAO_FAILURE });

    AlertError('Falha ao gerar próximo vencimento da conta! Tente novamente...');
  }
}

export default function* watchGerarContaAgoraConciliacao() {
  yield takeLatest(GERAR_CONTA_AGORA_CONCILIACAO, sagaGerarContaAgoraConciliacao)
}
